// Treatment Plan Constants
export const TREATMENT_PLAN_CONSTANTS = {
  // Pagination
  DEFAULT_PAGE_SIZE: 10,
  DEFAULT_PAGE: 1,

  // Filter Options
  GENERATED_BY_OPTIONS: {
    ALL: "all",
    YOU: "you",
    PRACTICE: "practice",
  } as const,

  DATE_RANGE_OPTIONS: {
    ALL_TIME: "all_time",
    LAST_7_DAYS: "last_7_days",
    LAST_3_MONTHS: "last_3_months",
    LAST_6_MONTHS: "last_6_months",
    LAST_12_MONTHS: "last_12_months",
    CUSTOM_RANGE: "custom_range",
  } as const,

  SORT_OPTIONS: {
    GENERATED_ON: "generated_on",
  } as const,

  SORT_ORDER_OPTIONS: {
    ASC: "asc",
    DESC: "desc",
  } as const,

  // UI Constants
  SEARCH_PLACEHOLDER:
    "Search by Protocol Name, Patient Name, or Generated By...",
  PROTOCOL_PREFIX: "Protocol-",
  PROTOCOL_ID_LENGTH: 8,

  // Column Headers
  COLUMN_HEADERS: {
    PROTOCOL_FOLDER_NAME: "Protocol Folder Name",
    GENERATED_ON: "Generated On",
    PATIENT_NAME: "Patient Name",
    GENERATED_BY: "Generated By",
    ACTIONS: "Actions",
  },

  // Date Format
  DATE_FORMAT: "MM/dd/yyyy HH:mm:ss",
  DATE_FORMAT_SHORT: "MMM dd, yyyy",
  API_DATE_FORMAT: "yyyy-MM-dd",

  // Styling
  BORDER_RADIUS: 2,
  MIN_WIDTH: {
    FORM_CONTROL: 150,
    DATE_PICKER: 150,
    SEARCH_FIELD: 400,
  },

  // Colors
  COLORS: {
    BACKGROUND_LIGHT: "#f8f9fa",
    BACKGROUND_HOVER: "#f5f5f5",
    BORDER_COLOR: "#e0e0e0",
    TEXT_SECONDARY: "text.secondary",
    TEXT_DISABLED: "text.disabled",
  },

  // Spacing
  SPACING: {
    SMALL: 1,
    MEDIUM: 2,
    LARGE: 3,
  },

  // Font Sizes
  FONT_SIZES: {
    SMALL: "0.75rem",
    MEDIUM: "0.875rem",
  },

  // Responsive Breakpoints
  BREAKPOINTS: {
    MOBILE: 768,
    HIGH_RESOLUTION: "2dppx",
  },

  // Messages
  MESSAGES: {
    SUCCESS: {
      TITLE: "Success",
      GENERATION: "Treatment plan generated successfully!",
    },
    LOADING: {
      GENERATING: "Generating...",
      REFRESHING: "Refreshing...",
    },
    BUTTONS: {
      REFRESH: "Refresh",
      GENERATE_PROTOCOL: "Generate Protocol",
      FILTERS: "Filters",
      CLEAR_FILTERS: "Clear Filters",
      VIEW_DETAILS: "View Details",
    },
    LABELS: {
      GENERATED_BY: "Generated By",
      DATE_RANGE: "Date Range",
      START_DATE: "Start Date",
      END_DATE: "End Date",
      ROWS_PER_PAGE: "Rows per page",
    },
    OPTIONS: {
      ALL: "All",
      YOU: "You",
      PRACTICE: "Practice",
      ALL_TIME: "All Time",
      LAST_7_DAYS: "Last 7 Days",
      LAST_3_MONTHS: "Last 3 Months",
      LAST_6_MONTHS: "Last 6 Months",
      LAST_12_MONTHS: "Last 12 Months",
      CUSTOM_RANGE: "Custom Range",
    },
    ERRORS: {
      INVALID_DATE: "Invalid date",
      GENERATION_FAILED: "Failed to generate treatment plan",
      REFRESH_FAILED: "Error manual refresh failed",
    },
  },

  // Query Keys
  QUERY_KEYS: {
    TREATMENT_PLANS: ["treatmentPlans"],
  },

  // Navigation
  ROUTES: {
    GENERATED_RESULT: "/treatment-plan/generated-result",
  },
} as const;

// Type definitions
export type GeneratedByOption =
  (typeof TREATMENT_PLAN_CONSTANTS.GENERATED_BY_OPTIONS)[keyof typeof TREATMENT_PLAN_CONSTANTS.GENERATED_BY_OPTIONS];
export type DateRangeOption =
  (typeof TREATMENT_PLAN_CONSTANTS.DATE_RANGE_OPTIONS)[keyof typeof TREATMENT_PLAN_CONSTANTS.DATE_RANGE_OPTIONS];
export type SortOption =
  (typeof TREATMENT_PLAN_CONSTANTS.SORT_OPTIONS)[keyof typeof TREATMENT_PLAN_CONSTANTS.SORT_OPTIONS];
export type SortOrderOption =
  (typeof TREATMENT_PLAN_CONSTANTS.SORT_ORDER_OPTIONS)[keyof typeof TREATMENT_PLAN_CONSTANTS.SORT_ORDER_OPTIONS];
